import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { authVerifyCodeLogin, authLogin } from '../server';

// 登录通过手机号和密码
export const loginUserWithPassword = createAsyncThunk(
    'auth/loginWithPassword',
    async ({ email, password }, { rejectWithValue }) => {
        try {
            const res = await authLogin({ email, password });
            if (res.code === 200) {
                const adminAuth = res.data.email;
                const token = res.data.token;
                const user = {
                    nickname: res.data?.nickname,
                    email: res.data?.email,
                    role: res.data?.role,
                    userId: res.data?.userId,
                };
                if (res.data.role) {
                    localStorage.setItem('user', JSON.stringify(user));
                    localStorage.setItem('token', token);
                    return { token, user, adminAuth };
                } else {
                    return rejectWithValue(res.msg);
                }
            } else {
                return rejectWithValue(res.msg || '服务器出错');
            }
        } catch (error) {
            return rejectWithValue(error.message || '服务器出错');
        }
    }
);

// 登录通过手机号和验证码
export const loginUserWithCode = createAsyncThunk(
    'auth/loginWithCode',
    async ({ email, code }, { rejectWithValue }) => {
        try {
            const res = await authVerifyCodeLogin({ email, code });
            const user = {
                nickname: res.data?.nickname,
                email: res.data?.email,
                role: res.data?.role,
                userId: res.data?.userId,
            };
            if (res.code === 200 && res.data.role) {
                localStorage.setItem('user', JSON.stringify(user));
                localStorage.setItem('token', res.data.token);
                return { token: res.data.token, user: user, adminAuth: res.data };
            } else {
                let str = res?.msg;
                return rejectWithValue(str);
            }
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// 登出逻辑
export const logoutUser = createAsyncThunk('auth/logout', async () => {
    localStorage.clear();
    sessionStorage.clear();
});

// 注册用户
// export const registerUser = createAsyncThunk(
//     'auth/register',
//     async ({ username, mobile, password, code }, { rejectWithValue }) => {
//         try {
//             const response = await authAPI.register(username, mobile, password, code);
//             if (response.code !== 200) {
//                 return rejectWithValue(response.message);
//             }
//             const token = response.headers.authorization;
//             if (token) {
//                 localStorage.setItem('token', token);
//                 return { token, user: response.data.datas, adminAuth: response.data }; // 返回 adminAuth
//             } else {
//                 return rejectWithValue('Token is missing');
//             }
//         } catch (error) {
//             return rejectWithValue(error.message);
//         }
//     }
// );

const authSlice = createSlice({
    name: 'auth',
    initialState: {
        user: JSON.parse(localStorage.getItem('user')),
        isAuthenticated: !!localStorage.getItem('token'),
        loading: false,
        error: null,
        adminAuth: null,
    },
    reducers: {
        clearError: (state) => {
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(loginUserWithPassword.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(loginUserWithPassword.fulfilled, (state, action) => {
                state.user = action.payload.user;
                state.isAuthenticated = true; // 登录成功后设置为已登录
                state.loading = false;
                state.adminAuth = action.payload.adminAuth; // 更新 adminAuth
            })
            .addCase(loginUserWithPassword.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(loginUserWithCode.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(loginUserWithCode.fulfilled, (state, action) => {
                state.user = action.payload.user;
                state.isAuthenticated = true;
                state.loading = false;
                state.adminAuth = action.payload.adminAuth; // 更新 adminAuth
            })
            .addCase(loginUserWithCode.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // .addCase(registerUser.pending, (state) => {
            //     state.loading = true;
            //     state.error = null;
            // })
            // .addCase(registerUser.fulfilled, (state, action) => {
            //     state.user = action.payload.user;
            //     state.isAuthenticated = true;
            //     state.loading = false;
            //     state.adminAuth = action.payload.adminAuth; // 更新 adminAuth
            // })
            // .addCase(registerUser.rejected, (state, action) => {
            //     state.loading = false;
            //     state.error = action.payload;
            // })
            .addCase(logoutUser.fulfilled, (state) => {
                state.user = null;
                state.isAuthenticated = false;
                state.adminAuth = null; // 清除 adminAuth
            });
    },
});

export const { clearError } = authSlice.actions;

export default authSlice.reducer;